import React from "react"
import Header from '../components/header'
import TopLinks from '../components/topLinks'

class SiteNavigation extends React.Component {
    constructor(props) {
        super(props);
        this.state = {degrees: 0};
    }

    rotate () {
        const original_degrees = this.state.degrees;
        this.setState({degrees: original_degrees + 6});
    }

    resetScreen () {
        this.setState({degrees: 0});
    }

    render() {
        return (
            <div className="content" 
                 style={{
                    transform: 'rotate(' + this.state.degrees + 'deg)',
                    marginTop: (this.state.degrees % 180) + 'px',
                    position: 'relative',
                    zIndex: '8',
                }}>
                <Header siteTitle='Shane Cummerford' />
                <TopLinks rotateScreen={this.rotate.bind(this)} 
                          resetScreen={this.resetScreen.bind(this)}
                          degrees={this.state.degrees}
                />
                <div className="content">
                    { this.props.children }
                </div>
            </div>
        );
    }
}

export default SiteNavigation;


// WEBPACK FOOTER //
// ./src/components/siteNavigation.js